const NO_ACTIVITY_COEF = 1.2;
const LOW_ACTIVITY_COEF = 1.375;
const NORMAL_ACTIVITY_COEF = 1.53;
const HIGH_ACTIVITY_COEF = 1.76;
const EXTREME_ACTIVITY_COEF = 2.25;

export const NO_ACTIVITY = 'NO_ACTIVITY';
export const LOW_ACTIVITY = 'LOW_ACTIVITY';
export const NORMAL_ACTIVITY = 'NORMAL_ACTIVITY';
export const HIGH_ACTIVITY = 'HIGH_ACTIVITY';
export const EXTREME_ACTIVITY = 'EXTREME_ACTIVITY';

export const ActivityCoefficient = Object.freeze({
    NO_ACTIVITY: NO_ACTIVITY_COEF,
    LOW_ACTIVITY: LOW_ACTIVITY_COEF,
    NORMAL_ACTIVITY: NORMAL_ACTIVITY_COEF,
    HIGH_ACTIVITY: HIGH_ACTIVITY_COEF,
    EXTREME_ACTIVITY: EXTREME_ACTIVITY_COEF
});
